import client from './client';

export interface AkimSlot {
  id: number;
  date: string;
  time_start: string;
  time_end: string;
  max_visitors: number;
  booked_count: number;
  is_active: boolean;
  note?: string;
}

export interface AkimAppointment {
  id: number;
  user_id: number;
  slot_id: number;
  topic: string;
  description?: string;
  status: 'pending' | 'confirmed' | 'cancelled' | 'completed';
  user_name?: string;
  user_phone?: string;
  slot_date?: string;
  slot_time_start?: string;
  slot_time_end?: string;
  created_at: string;
}

export interface SlotCreatePayload {
  date: string;
  time_start: string;
  time_end: string;
  max_visitors: number;
  note?: string;
}

export interface AppointmentStats {
  total_slots: number;
  booked_slots: number;
  pending_appointments: number;
}

export const appointmentsApi = {
  listSlots: (params?: Record<string, any>) =>
    client.get<AkimSlot[]>('/api/admin/appointments/slots', { params }),

  createSlot: (data: SlotCreatePayload) =>
    client.post('/api/admin/appointments/slots', data),

  bulkCreateSlots: (data: SlotCreatePayload[]) =>
    client.post('/api/admin/appointments/slots/bulk', data),

  updateSlot: (id: number, data: Partial<AkimSlot>) =>
    client.patch(`/api/admin/appointments/slots/${id}`, data),

  deleteSlot: (id: number) =>
    client.delete(`/api/admin/appointments/slots/${id}`),

  listAppointments: (params?: Record<string, any>) =>
    client.get<AkimAppointment[]>('/api/admin/appointments', { params }),

  updateAppointmentStatus: (id: number, status: string) =>
    client.patch(`/api/admin/appointments/${id}/status`, { status }),

  stats: () =>
    client.get<AppointmentStats>('/api/admin/appointments/stats'),
};
